import { API_BASE_URL } from "@fleet-os/api-client";

const BASE = API_BASE_URL;

async function get(path) {
  const res = await fetch(`${BASE}/api/training${path}`);
  if (!res.ok) throw new Error(`${path} → ${res.status}`);
  return res.json();
}

export const api = {
  state: () => get("/state"),
  action: (body) =>
    fetch(`${BASE}/api/training/action`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then((r) => r.json()),
  sync: () =>
    fetch(`${BASE}/api/training/sync`, { method: "POST" }).then((r) => r.json()),
};
